import * as process from 'process';

import { App } from 'vue';
import { Centrifuge } from 'centrifuge';
import { CentrifugeKey } from 'SharedDir/common/composables/useCentrifuge';
import { CENTRIFUGE_URL } from 'SharedDir/constants/app/endpoints';
import { useAuthStore } from 'SharedDir/stores/auth.store';

/**
 * Синглтон интстанса центрифуги.
 *
 * Дело в том, что центрифуга (ее экземляр) создается с конфигами,
 * которые в дальнейшем, штатными средствами поменять очень сложно.
 * Только если руками лезть в приватные свойства.
 *
 * для обеспечения работы с единым экземпляром ценрифуги,
 * нам необходимо ее провайдить на уровне приложения.
 *
 * По этому экземпляр храниться в этой переменной.
 */
let centrifuge: Centrifuge;

export const StartUp = (app: App, store): Centrifuge | undefined => {
  const state = useAuthStore(store);
  if (!CENTRIFUGE_URL) {
    return;
  }
  function getCentrifuge() {
    return new Centrifuge(CENTRIFUGE_URL as string, {
      token: state.token,
      getToken: async () => {
        console.debug('Start centrifuge token refreshing ...');
        return state.doRefreshToken()
          .then((token) => token)
          .catch(err => {
            return '';
          });
      },
      // debug: process.env.NODE_ENV === 'development',
    });
  }

  centrifuge = getCentrifuge();
  state.$onAction(({ name, args, after }) => {
    if (name === 'setToken') {
      const [token] = args;
      if (token) {
        // У пиньи подписка на действия немного отличается от вьюкса.
        // Сначала уведомляется подписант на это событие, а потом уже происходит это самое событие.
        // Так что подключатся к серверу ценрифуги надо после этого события
        after(() => {
          centrifuge = getCentrifuge();
          centrifuge.connect();
        });
      } else {
        after(() => {
          centrifuge.disconnect();
        });
      }
    }
  });
  // Провадиться не сам обеъкт, а замыкание которое его возвращает,
  // потому что объект передается не по ссылке.
  app.provide(CentrifugeKey, () => centrifuge);
};
